function getDateAsString(date) {
    const dateString = [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('/');
    return dateString;
}

export {
    getDateAsString
}